function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  id: "defs2"
});

var _ref3 = /*#__PURE__*/React.createElement("metadata", {
  id: "metadata5"
}, /*#__PURE__*/React.createElement("useless", null, /*#__PURE__*/React.createElement("useless", {
  useless: ""
}, /*#__PURE__*/React.createElement("useless", null, "image/svg+xml"), /*#__PURE__*/React.createElement("useless", {
  useless: "http://purl.org/dc/dcmitype/StillImage"
}), /*#__PURE__*/React.createElement("useless", null))));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0,-275.83332)",
  id: "layer1"
}, /*#__PURE__*/React.createElement("path", {
  id: "path1377",
  d: "m 13.318952,281.48582 a 0.64351209,0.6006435 0 0 0 -0.643803,0.60091 v 9.11366 H 9.8858349 v -4.76511 A 0.64351209,0.6006435 0 0 0 9.2420314,285.83436 H 5.9310412 a 0.64351209,0.6006435 0 1 0 0,1.20043 h 2.6686944 v 4.76511 a 0.64351209,0.6006435 0 0 0 0.6422958,0.60091 h 4.0769206 a 0.64351209,0.6006435 0 0 0 0.643804,-0.60091 v -9.11225 h 2.382225 v 3.8391 a 0.64351209,0.6006435 0 0 0 0.642296,0.60092 h 3.466288 a 0.64351209,0.6006435 0 1 0 0,-1.20042 h -2.822484 v -3.84052 a 0.64351209,0.6006435 0 0 0 -0.643804,-0.60091 z"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "layer2"
}, /*#__PURE__*/React.createElement("path", {
  id: "path964-7",
  d: "m 0.0326021,14.297176 c 1.3291096,0 2.5743666,-0.66855 3.2623336,-1.796272 0.687967,-1.127722 0.687967,-2.5537067 0,-3.6814287 -0.687967,-1.127722 -1.933224,-1.796273 -3.2623336,-1.796273 v 2.140438 c 0.6087621,0 1.1546012,0.309927 1.4355716,0.770495 0.280969,0.4605697 0.280969,0.9915397 0,1.4521077 -0.2809704,0.460568 -0.8268095,0.770496 -1.4355716,0.770496 z"
}), /*#__PURE__*/React.createElement("rect", {
  transform: "scale(-1,1)",
  ry: 9.5216132e-7,
  y: 9.5429449,
  x: -5.317215,
  height: 2.0670574,
  width: 1.7831526,
  id: "rect962"
}));

var SvgSqWave = function SvgSqWave(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg8",
    viewBox: "0 0 21.166666 21.166667",
    height: 80,
    width: 80,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSqWave, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sq-wave.523aaa1e.svg";
export { ForwardRef as ReactComponent };